import {Platform, StyleSheet} from 'react-native';

const THEME = {
  dish: { bg: '#2E7D32', bgPressed: '#1B5E20' },  // ConsumeGetEatFromProvider Well - green
  live: { bg: '#1565C0', bgPressed: '#0D47A1' },  // ConsumeGetLiveFromProvider Well - blue
  move: { bg: '#EF6C00', bgPressed: '#E65100' },  // ConsumeGetMoveFromProvider Forward - orange
};
const HEADER_COLORS = {
  bg: '#F2F5FA',     // light cool-gray (not blue), contrasts gently with blue
  text: '#0F172A',   // near-black for strong readability
  border: '#D8E1EE', // soft cool-gray border
};
const HEADER_BG = '#EF6C00';


const mystyles = StyleSheet.create({
  safe: {
    flex: 1,
    backgroundColor: '#F2F2F7',
  },
  flex: {
    flex: 1,
  },
  scroll: {
    flexGrow: 1,
    paddingHorizontal: 20,
    paddingVertical: 16,
    justifyContent: 'center',
  },
  card: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    padding: 12,
    marginBottom: 12,
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: '#E5E7EB',

    // iOS shadow
    shadowColor: '#000',
    shadowOpacity: 0.08,
    shadowRadius: 8,
    shadowOffset: { width: 0, height: 4 },

    // Android elevation
    elevation: 3,
  },
  form: {
    gap: 12, // React Native 0.79+ supports gap
  },
  input: {
    height: 48,
    paddingHorizontal: 14,
    paddingVertical: Platform.select({ ios: 12, android: 10, default: 10 }),
    borderWidth: 1,
    borderColor: '#E5E5EA',
    backgroundColor: '#FFFFFF',
    borderRadius: 10,
    fontSize: 12,
    color: '#1C1C1E',
  },
  buttonWrapper: {
    marginTop: 4,
    borderRadius: 10,
    overflow: 'hidden', // keeps Android ripple contained
  },
  message: {
    marginTop: 12,
    fontSize: 14,
    color: '#0A7E07',
  },
  container: {
    flex: 1,
    backgroundColor: '#F6F7F9',
    paddingHorizontal: 16,
    paddingVertical: 24,
    justifyContent: 'center',
  },
  title: {
    fontSize: 12,
    fontWeight: '600',
    color: '#11181C',
    marginBottom: 12,
    textAlign: 'center',
  },

  primaryBtn: {
    height: 48,
    borderRadius: 8,
    backgroundColor: '#007AFF', // iOS blue (looks good on Android too)
    alignItems: 'center',
    justifyContent: 'center',
  },
  primaryBtnText: {
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: '600',
  },
  secondaryBtn: {
    height: 48,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#007AFF',
    backgroundColor: 'transparent',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 10,
  },
  secondaryBtnText: {
    color: '#007AFF',
    fontSize: 16,
    fontWeight: '600',
  },
  linkContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'center',
    marginTop: 16,
    paddingVertical: 12,
    paddingHorizontal: 14,
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderColor: '#E5E5EA',
    borderRadius: 12,
    // iOS shadow
    shadowColor: '#000',
    shadowOpacity: 0.08,
    shadowRadius: 8,
    shadowOffset: { width: 0, height: 3 },
    // Android elevation
    elevation: 2,
  },
  linkPrompt: {
    color: '#6B7280',
    fontSize: 14,
  },
  linkBtn: {
    marginLeft: 6,
    paddingHorizontal: 6,
    paddingVertical: 4,
    borderRadius: 8,
  },
  linkBtnPressed: {
    backgroundColor: '#EAF2FF',
  },
  linkText: {
    color: '#007AFF',
    fontSize: 14,
    fontWeight: '600',
    textDecorationLine: 'underline',
  },
  formCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: 20,
    gap: 14,
    shadowColor: '#000',
    shadowOpacity: 0.08,
    shadowRadius: 12,
    shadowOffset: { width: 0, height: 6 },
    elevation: 4,
  },
  inputWrapper: {
    gap: 6,
  },
  inputLabel: {
    fontSize: 12,
    fontWeight: '600',
    color: '#6B7280',
    letterSpacing: 0.2,
  },
  inputRow: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#F3F4F6',
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#E5E7EB',
    paddingHorizontal: 12,
    height: 48,
  },
  inputIcon: {
    fontSize: 16,
    marginRight: 8,
  },

  primaryBtnPressed: {
    transform: [{ scale: 0.98 }],
    opacity: 0.9,
  },

  cardAlt: {
    backgroundColor: '#F9FAFB',
  },
  description: {
    fontSize: 10,
    lineHeight: 20,
    color: '#374151',
    marginBottom: 6,
  },
  service: {
    fontSize: 14,
    color: '#6B7280',
  },
  headerTitle: {
    fontSize: 12,
    fontWeight: '700',
    color: '#111827',
    backgroundColor: '#FFFFFF',
    paddingHorizontal: 16,
    paddingTop: 8,
    paddingBottom: 10,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: '#E5E7EB',
  },

  scrollContent: {
    paddingHorizontal: 16,
    paddingTop: 8,
    paddingBottom: 24,
    // Use gap if your RN version supports it; otherwise use margins on children
    gap: 12,
    alignItems: 'stretch',
    justifyContent: 'flex-start',
  },
  inputFocused: {
    borderColor: '#2563EB',
    shadowOpacity: 0.1,
    elevation: 3,
  },
  backgroundWhite: {
    backgroundColor: '#FFFFFF'
  },
  backgroundBlack: {
    backgroundColor: '#000000'
  },
  borders: {color:'black', borderWidth: 1, borderRadius: 5},
  textColor: {color:'black', fontWeight:'bold'},


  resultsCard: {
    marginTop: 14,
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: 12,
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: '#E5E7EB',
    shadowColor: '#000',
    shadowOpacity: 0.06,
    shadowRadius: 8,
    shadowOffset: { width: 0, height: 3 },
    elevation: 2,
  },


  helperText: {
    fontSize: 10,
    color: '#6B7280',
  },
  helperTextValue: {
    color: '#11181C',
    fontWeight: '600',
  },

  primaryBtnDisabled: {
    backgroundColor: '#B8D3FF',
  },


  header: {
    backgroundColor: '#0A84FF',
    paddingHorizontal: 20,
    paddingTop: Platform.select({ ios: 12, android: 14, default: 14 }),
    paddingBottom: 14,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: 'rgba(255,255,255,0.25)',
    // iOS shadow
    shadowColor: '#000',
    shadowOpacity: 0.08,
    shadowRadius: 6,
    shadowOffset: { width: 0, height: 2 },
    // Android elevation
    elevation: 2,
  },

  content: {
    flexGrow: 1,
    paddingHorizontal: 20,
    paddingTop: 16,
    paddingBottom: 24,
  },


  screen: {
    flex: 1,
    paddingHorizontal: 2,
    paddingVertical: 2,
    backgroundColor: '#F2F2F7',
    justifyContent: 'center',
  },

  centerContainer: {
    // Centers the child horizontally and vertically
    alignItems: 'center',
    justifyContent: 'center',

    // Spacing
    paddingVertical: 12,
    paddingHorizontal: 16,
    marginVertical: 16,

    // Make the container span the available width
    alignSelf: 'stretch',
  },
  orText: {
    textAlign: 'center',
    fontSize: 10,
    fontWeight: '600',
    color: '#333',
  },

  section: {
    flex: 1,
    padding: 16,
    paddingTop: 32,
    backgroundColor: '#fff',
  },
  sectionTitle: {
    fontSize: 24,
    fontWeight: '600',
  },
  sectionHint: {
    marginTop: 8,
    color: '#555',
  },

  // New styles for distinct submit button
  submitContainer: {
    padding: 16,
    paddingTop: 8,
  },
  submitButton: {
    backgroundColor: '#0A84FF',
    borderRadius: 12,
    paddingVertical: 14,
    paddingHorizontal: 16,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 48,
    elevation: 2, // Android
    shadowColor: '#000', // iOS
    shadowOpacity: 0.12,
    shadowRadius: 8,
    shadowOffset: { width: 0, height: 4 },
  },
  submitButtonPressed: {
    transform: [{ scale: 0.98 }],
  },
  submitButtonDisabled: {
    backgroundColor: '#9CC8FF',
  },
  submitButtonText: {
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: '700',
    letterSpacing: 0.2,
    marginLeft: 8,
  },
  submitContent: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  feedbackError: {
    marginTop: 8,
    color: '#cc0000',
    textAlign: 'center',
  },
  feedbackSuccess: {
    marginTop: 8,
    color: '#117A00',
    textAlign: 'center',
  },

  cardBtn: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 24,
  },
  cardBtnPressed: {
    opacity: 0.9,
  },
  cardTitle: {
    fontSize: 18,
    fontWeight: '600',
  },
  spacer: { height: 16 },
  backLink: {
    marginBottom: 12,
    alignSelf: 'flex-start',
  },
  backText: {
    color: '#0A84FF',
    fontWeight: '600',
    fontSize: 16,
  },


  multiline: {
    height: 100,
    textAlignVertical: 'top',
  },
  dropdownContainer: { position: 'relative' },
  dropdownButton: {
    borderWidth: 1,
    borderColor: '#ccc',
    paddingHorizontal: 12,
    paddingVertical: 10,
    borderRadius: 8,
    backgroundColor: '#fff',
  },
  dropdownButtonText: { fontSize: 16 },
  dropdownMenu: {
    position: 'absolute',
    top: 48,
    left: 0,
    right: 0,
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 8,
    zIndex: 10,
    overflow: 'hidden',
  },
  dropdownItem: { paddingHorizontal: 12, paddingVertical: 10 },
  dropdownItemSelected: { backgroundColor: '#F0F6FF' },
  dropdownItemText: { fontSize: 16 },

  // Button color variants
  eatBtn: { backgroundColor: THEME.dish.bg, borderColor: THEME.dish.bg },
  eatBtnPressed: { backgroundColor: THEME.dish.bgPressed, borderColor: THEME.dish.bgPressed },

  liveBtn: { backgroundColor: THEME.live.bg, borderColor: THEME.live.bg },
  liveBtnPressed: { backgroundColor: THEME.live.bgPressed, borderColor: THEME.live.bgPressed },

  moveBtn: { backgroundColor: THEME.move.bg, borderColor: THEME.move.bg },
  moveBtnPressed: { backgroundColor: THEME.move.bgPressed, borderColor: THEME.move.bgPressed },

  // Result container matches the selected action color
  resultContainer: {
    marginTop: 16,
    borderRadius: 12,
    padding: 12,
  },
  resultEatBg: { backgroundColor: THEME.dish.bg },
  resultLiveBg: { backgroundColor: THEME.live.bg },
  resultMoveBg: { backgroundColor: THEME.move.bg },

  // Optional inner card to keep content readable over colored background
  resultInnerCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 10,
    overflow: 'hidden',
  },
  resultTitle: {
    color: '#FFFFFF',
    fontWeight: '600',
    marginBottom: 8,
  },
  helpButton: {
    marginTop: 12,
    paddingVertical: 12,
    paddingHorizontal: 16,
    backgroundColor: '#1976d2',
    borderRadius: 8,
    alignItems: 'center',
  },
  helpButtonText: {
    color: '#ffffff',
    fontWeight: '600',
  },



  subtitle: {
    fontSize: 14,
    color: '#555',
    marginBottom: 16,
  },
  buttonRow: {
    flexDirection: 'row',
    gap: 12,
    marginBottom: 16,
    justifyContent: 'space-between',
  },
  button: {
    flex: 1,
    backgroundColor: '#246BFD',
    paddingVertical: 14,
    borderRadius: 8,
    alignItems: 'center',
  },
  buttonActive: {
    backgroundColor: '#194EC3',
  },
  buttonText: {
    color: '#fff',
    fontWeight: '600',
  },
  centered: {
    marginTop: 24,
    alignItems: 'center',
  },
  loadingText: {
    marginTop: 8,
    color: '#333',
  },
  errorBox: {
    marginTop: 16,
    padding: 12,
    backgroundColor: '#FEE2E2',
    borderRadius: 8,
  },
  errorText: {
    color: '#B91C1C',
  },
  results: {
    marginTop: 8,
    flex: 1,
  },
  resultsTitle: {
    fontSize: 16,
    fontWeight: '600',
    marginBottom: 8,
  },
  mono: {
    fontFamily: Platform.select({ ios: 'Menlo', android: 'monospace', default: 'monospace' }),
    fontSize: 12,
    color: '#111',
  },
  rawScroll: {
    flex: 1,
  },
  // Table styles
  tableScroll: {
    flex: 1,
  },
  tableContent: {
    paddingBottom: 12,
  },
  table: {
    minWidth: '100%',
    borderWidth: 1,
    borderColor: '#DDD',
    borderRadius: 8,
    overflow: 'hidden',
  },
  // Updated to a matching brand blue to make the header stand out
  tableHeaderRow: {
    backgroundColor: HEADER_BG
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#EEE',
  },
  tableRowAlt: {
    backgroundColor: '#FAFAFA',
  },
  tableCell: {
    paddingVertical: 10,
    paddingHorizontal: 8,
    justifyContent: 'center',
    borderRightWidth: 1,
    borderRightColor: '#EEE',
  },
  tableHeaderCell: {
    borderRightColor: '#E5E7EB',
  },
  // Switched to white text for contrast on the blue header
  tableHeaderText: {
    fontWeight: '700',
    color: '#FFFFFF',
  },
  tableCellText: {
    color: '#111',
    // Ensure long content wraps within the cell width
    flexShrink: 1,
    width: '100%',
  },
  tableBodyScroll: {
    maxHeight: 420,
  },
  adCard: {
    backgroundColor: '#FFF8E7',
    borderColor: '#FFD38A',
    borderWidth: 1,
  },
  adCardPressed: {
    opacity: 0.9,
  },
  adHeader: {
    marginBottom: 6,
    flexDirection: 'row',
    alignItems: 'center',
  },
  adBadge: {
    paddingHorizontal: 8,
    paddingVertical: 2,
    borderRadius: 4,
    fontSize: 12,
    color: '#8B5E00',
    backgroundColor: '#FFE6B3',
    alignSelf: 'flex-start',
  },
  adTitle: {
    fontSize: 16,
    fontWeight: '700',
    color: '#3A2E00',
    marginBottom: 4,
  },
  adSubtitle: {
    fontSize: 14,
    color: '#5C4B00',
    marginBottom: 10,
  },
  adCta: {
    fontSize: 14,
    color: '#8B5E00',
    fontWeight: '600',
  },
  tinyButton: {
    alignSelf: 'flex-start',
    paddingHorizontal: 8,
    paddingVertical: 2,
    minHeight: 22,
    borderRadius: 6,
    backgroundColor: '#0A84FF',
  },
  tinyButtonText: {
    paddingVertical: 5,
    fontSize: 10,
    color: '#fff',
    fontWeight: '600',
    letterSpacing: 0.2,
  },
  followButton: {
    marginTop: 8,
    alignSelf: 'flex-start',
    backgroundColor: '#2563eb',
    paddingHorizontal: 14,
    paddingVertical: 10,
    borderRadius: 6,
  },
  followButtonPressed: {
    backgroundColor: '#1e40af',
  },
  followButtonDisabled: {
    opacity: 0.6,
  },
  followButtonText: {
    color: '#ffffff',
    fontWeight: '600',
  },








  center: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  itemContainer: {
    padding: 10,
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
  },
  itemText: {
    fontSize: 16,
  },

  emptyText: {
    textAlign: 'center',
    marginTop: 20,
    fontSize: 16,
    color: '#666',
  },
  listContent: {
    paddingVertical: 10,
  },
  userCard: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#fff',
    padding: 15,
    borderRadius: 12,
    marginBottom: 12,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3, // Android shadow
    borderWidth: 1,
    borderColor: '#f0f0f0',
  },
  avatarCircle: {
    width: 50,
    height: 50,
    borderRadius: 25,
    backgroundColor: '#4A90E2',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 15,
  },
  avatarInitials: {
    color: '#fff',
    fontSize: 20,
    fontWeight: 'bold',
  },
  userInfo: {
    flex: 1,
  },
  userLabel: {
    fontSize: 12,
    color: '#888',
    marginBottom: 4,
    textTransform: 'uppercase',
  },
  userId: {
    fontSize: 16,
    fontWeight: '600',
    color: '#333',
  },




  profileImage: {
    width: 100,
    height: 100,
    borderRadius: 50,
    marginBottom: 10,
  },
  largeAvatar: {
    width: 100,
    height: 100,
    borderRadius: 50,
    marginBottom: 10,
    justifyContent: 'center',
    alignItems: 'center',
  },

  servicesContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  serviceTag: {
    backgroundColor: '#e0e0e0',
    borderRadius: 15,
    paddingHorizontal: 10,
    paddingVertical: 5,
    marginRight: 5,
    marginBottom: 5,
  },
  serviceText: {
    fontSize: 14,
  },
  serviceButton: {
    backgroundColor: '#4A90E2',
    paddingVertical: 10,
    paddingHorizontal: 15,
    borderRadius: 20,
    marginRight: 10,
    marginBottom: 10,
    elevation: 3, // Android shadow
    shadowColor: '#000', // iOS shadow
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 3,
  },
  serviceButtonText: {
    color: '#fff',
    fontWeight: '600',
    fontSize: 14,
  },
  contentImage: {
    width: '100%',
    height: 200,
    marginTop: 10,
    borderRadius: 8,
  },
});

export default mystyles;
